import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/BrandAvatar.svg?webp'


const _withScopeId = n => (_pushScopeId("data-v-25df4449"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vh-100 overflow-hidden d-flex flex-column justify-space-between" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = {
  ref: "chatContent",
  class: "chat-content d-flex flex-column"
}
const _hoisted_4 = {
  key: 0,
  class: "flex-shrink-0 bg-gray-06 px-3 py-2",
  ref: "application"
}
const _hoisted_5 = { class: "schedule-wrapper" }
const _hoisted_6 = { class: "border border-outline-color" }
const _hoisted_7 = { class: "text-size-16" }
const _hoisted_8 = { class: "expand-button-icon" }
const _hoisted_9 = { class: "d-flex flex-column-reverse" }
const _hoisted_10 = { class: "d-flex align-items-end" }
const _hoisted_11 = {
  key: 0,
  class: "message-item__avatar"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "message-item__avatar"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 2,
  class: "message-item__is-read"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "message-item__time text-size-12" }
const _hoisted_19 = {
  ref: "footer",
  class: "fixed-footer fixed-bottom flex-shrink-0 overflow-hidden bg-gray-06 px-3 pt-1 relative"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "send-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!
  const _component_TextAreaGroup = _resolveComponent("TextAreaGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { ref: "header" }, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode(),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
      ], undefined, true),
      _: 1
    }, 512),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.application)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "w-100 text-center expand-button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchExpandOrder && _ctx.switchExpandOrder(...args)))
                }, [
                  _createElementVNode("span", _hoisted_7, "\n                勤務予定を" + _toDisplayString(_ctx.isOrderExpanded ? "閉じる" : "開く"), 1),
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.isOrderExpanded)
                      ? (_openBlock(), _createBlock(_component_FeatherIcon, {
                          key: 0,
                          icon: "chevron-up",
                          class: "mr-1"
                        }))
                      : (_openBlock(), _createBlock(_component_FeatherIcon, {
                          key: 1,
                          icon: "chevron-down",
                          class: "mr-1"
                        }))
                  ])
                ])
              ]),
              _createTextVNode(),
              (_ctx.isOrderExpanded)
                ? (_openBlock(), _createBlock(_component_ApplicationCard, {
                    key: 0,
                    class: "application-card",
                    application: _ctx.application,
                    isSimpleDisplay: true
                  }, null, 8, ["application"]))
                : _createCommentVNode("", true)
            ])
          ], 512))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createElementVNode("div", {
        ref: "messageArea",
        class: "message-area flex-grow-1",
        style: _normalizeStyle(_ctx.messageAreaStyles),
        onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onTalkScroll && _ctx.onTalkScroll(...args)))
      }, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (message) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'message' + message.id,
              class: _normalizeClass(
              'senderType' in message && message.senderType === 'worker'
                ? 'message-item self'
                : 'message-item'
            )
            }, [
              _createElementVNode("div", _hoisted_10, [
                (message.senderType === 'staff')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (message.senderType === 'office')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: _ctx.office?.managerAvatar
                      }, null, 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.isRead(message))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, "\n                既読\n              "))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getMessageItemContentClass(message))
                }, [
                  _createElementVNode("p", {
                    class: "message-item__text text-size-14 mb-2 text-break",
                    innerHTML: _ctx.linkifyText(message.text)
                  }, null, 8, _hoisted_17),
                  _createTextVNode(),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.formatFromISOString(message.createdAt)), 1)
                ], 2)
              ])
            ], 2))
          }), 128))
        ]),
        _createTextVNode(),
        (!_ctx.isPageAtBottom)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "arrow-to-bottom",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollBottomMessage && _ctx.scrollBottomMessage(...args)))
            }, [
              _createVNode(_component_FeatherIcon, { icon: "arrow-down" })
            ]))
          : _createCommentVNode("", true)
      ], 36)
    ], 512),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_CustomValidationObserver, { ref: "vObserver" }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_BForm, { class: "d-flex align-items-end" }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                class: "flex-grow-1 align-items-center",
                name: "コメント",
                rules: { max: 2000 },
                modelValue: _ctx.inputText,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputText) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_TextAreaGroup, {
                    modelValue: _ctx.inputText,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputText) = $event)),
                    type: "text",
                    rows: 2,
                    maxRows: 5,
                    validationState: validationState,
                    enableTextareaAutoResize: true
                  }, null, 8, ["modelValue", "validationState"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createTextVNode(),
              _createElementVNode("button", {
                type: "button",
                class: "d-block ml-2 mb-1 flex-shrink-0",
                onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmitButton))
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_FeatherIcon, { icon: "send" })
                ])
              ], 8, _hoisted_20)
            ], undefined, true),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 512)
    ], 512)
  ]))
}